// extracted by mini-css-extract-plugin
export default {"modal":"MoveResourceModal-module__modal__n1tpA","content":"MoveResourceModal-module__content__ESiiU","alert":"MoveResourceModal-module__alert__Do-Eg"};